import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import "./Hero.css";

const Hero = () => {
  const navigate = useNavigate();
  
  const titleWords = ["Delicious", "Food,", "Delivered", "Fast"];

  return (
    <section className="hero-section">
      <div className="hero-bg-split"></div>
      
      <div className="hero-container">
        {/* Left Side: Content */}
        <div className="hero-content">
          <motion.div 
            className="hero-badge"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            🚀 30-min delivery guaranteed
          </motion.div>
          
          <h1 className="hero-title">
            {titleWords.map((word, index) => (
              <motion.span
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className={word === "Fast" ? "text-gradient" : ""}
              >
                {word}
              </motion.span>
            ))}
          </h1>
          
          <motion.p 
            className="hero-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            Order from the best restaurants in your city. Fresh, hot, and always on time.
          </motion.p>
          
          <motion.div 
            className="hero-search-wrapper"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.8 }}
          >
            <input 
              type="text" 
              className="hero-search-input" 
              placeholder="Search food, restaurants..." 
              onFocus={() => navigate("/menu")}
            />
            <button className="hero-search-btn" onClick={() => navigate("/menu")}>
              Search
            </button>
          </motion.div>
          
          <div className="hero-trust-badges">
            <div className="trust-badge">
              <span>⭐</span>
              <div>
                <CountUp end={4.8} decimals={1} duration={2} delay={1} /> Rating
              </div>
            </div>

            <div className="trust-badge">
              <span>😊</span>
              <div>
                <CountUp end={50} duration={2} delay={1} />K+ Happy Customers
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Image */}
        <div className="hero-image-wrapper">
          <div className="hero-blob"></div>
          <img 
            src="https://images.unsplash.com/photo-1546069901-ba9599a7e63c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
            alt="Delicious bowl" 
            className="hero-main-img" 
          />
          
          <motion.div 
            className="orbit-card card-top-right"
            animate={{ y: [0, -10, 0] }}
            transition={{ repeat: Infinity, duration: 2.5, ease: "easeInOut" }}
          >
            🍕 Pizza - ₹199
          </motion.div>

          <motion.div 
            className="orbit-card card-bottom-left"
            animate={{ y: [0, -15, 0] }}
            transition={{ repeat: Infinity, duration: 3, delay: 0.5, ease: "easeInOut" }}
          >
            ⭐ 4.9 Rating
          </motion.div>

          <motion.div 
            className="orbit-card card-bottom-right"
            animate={{ y: [0, -10, 0] }}
            transition={{ repeat: Infinity, duration: 2.2, delay: 1, ease: "easeInOut" }}
          >
            🕐 25 min
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
